<!-- TODO: Fix these eslint rules after reflecting on how to properly check accessibility for this component -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/aria-role -->
<template>
  <li
    role="step"
    class="sb-step"
    tabindex="-1"
    :class="computedClass"
    :aria-current="isActive && 'step'"
    :data-step-id="stepIndex"
    @click="handleClick"
    @keydown="handleKeyPress"
  >
    <div class="sb-step__content">
      <p class="sb-step__label">{{ step.label }}</p>
      <p v-if="isVertical" class="sb-step__description">
        {{ step.description }}
      </p>
    </div>
    <div v-if="isSmaller">
      <SbIcon
        :class="{ 'sb-step__marker--completed': isCompleted }"
        :color="isCompleted ? 'brand-color' : undefined"
        :name="isCompleted ? 'circle-check' : 'circle'"
      />
    </div>
    <div v-else class="sb-step__marker">
      <SbIcon
        v-if="isCompleted"
        name="check"
        color="tertiary"
        data-testid="completed"
      />
    </div>
  </li>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import SbIcon from '../../../Icon/SbIcon.vue'
import type { Step } from '../../types'

export type SbStepProps = {
  step: Step
  stepIndex: number
  isActive?: boolean
  isCompleted?: boolean
  isVertical?: boolean
  isSmaller?: boolean
}

const props = withDefaults(defineProps<SbStepProps>(), {
  isActive: false,
  isCompleted: false,
  isVertical: false,
  isSmaller: false,
})

const emit = defineEmits<{
  (e: 'step-click', step: Step): void
  (e: 'step-key-press', event: KeyboardEvent, step: Step): void
}>()

const computedClass = computed((): Record<string, boolean> => {
  return {
    'sb-step--active': props.isActive,
    'sb-step--completed': props.isCompleted,
    'sb-step--vertical': props.isVertical,
    'sb-step--smaller': props.isSmaller,
  }
})

function handleClick(): void {
  emit('step-click', props.step)
}

function handleKeyPress(event: KeyboardEvent): void {
  emit('step-key-press', event, props.step)
}
</script>
<style lang="scss">
@import 'step';
</style>
